import * as Yup from 'yup';
import { FormTemplate } from '@models';

export function useValidationSchema() {
  return Yup.object<FormTemplate>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    workOrderTypes: Yup.array().nullable().required('Povinné pole'),
  }) as Yup.Schema<FormTemplate>;
}
